import { NotepadText } from '@chain-zen/ui'

interface InstructionsDisplayProps {
  instructions: string
}

/**
 * Display component for showing warehouse instructions in read-only mode
 */
export const InstructionsDisplay = ({ instructions }: InstructionsDisplayProps) => {
  if (!instructions) return null

  return (
    <div className="flex items-start gap-2 rounded-md bg-background p-2">
      <NotepadText className="h-3.5 w-3.5 text-muted-foreground shrink-0 mt-0.5" />
      <p className="text-xs text-muted-foreground leading-relaxed">{instructions}</p>
    </div>
  )
}
